import {
  ResendVerification,
  ResetPassword,
  SignIn,
  SignUp,
} from "components/user";
import GeoscapeDeveloperSvg from "icons/hub-logo-signIn.svg?react";
import { Redirect, Route, Switch, useLocation } from "react-router";
import * as Routes from "routes";
import { saveRedirectInfo } from "utils/redirect-manager";
import useDarkMode from "use-dark-mode";

import MarketingPage from "./marketing";

export const SignedOut = () => {
  const { value: isDark } = useDarkMode();

  const prevLocation = useLocation();
  if (
    prevLocation.pathname !== "/sign-in" &&
    prevLocation.pathname !== "/sign-up" &&
    prevLocation.pathname !== "/"
  ) {
    saveRedirectInfo(prevLocation.pathname, prevLocation.search);
  }

  return (
    <div className="flex flex-col justify-center items-center min-h-screen relative">
      <Switch>
        <Route exact path={Routes.signIn}>
          <div className="flex flex-col items-center justify-center gap-2">
            <GeoscapeDeveloperSvg
              fill={isDark ? "white" : "black"}
              className="w-[80vw] h-[100px]"
            />
            <SignIn />
          </div>
        </Route>
        <Route exact path={"/"}>
          <div className="flex flex-col items-center justify-center gap-2">
            <GeoscapeDeveloperSvg
              fill={isDark ? "white" : "black"}
              className="w-[80vw] h-[100px]"
            />
            <SignIn />
          </div>
        </Route>
        <Route exact path={Routes.signUp}>
          <div className="flex justify-center items-center">
            <div className="flex flex-col md:flex-row w-auto max-w-full">
              <div className="flex justify-center md:justify-end">
                <MarketingPage />
              </div>
              <div className="flex justify-center md:justify-start">
                <SignUp />
              </div>
            </div>
          </div>
        </Route>
        <Route exact path={Routes.resetPassword}>
          <div className="flex flex-col items-center justify-center gap-2">
            <GeoscapeDeveloperSvg
              fill={isDark ? "white" : "black"}
              className="w-[80vw] h-[100px]"
            />
            <ResetPassword />
          </div>
        </Route>
        <Route exact path={Routes.resendVerification}>
          <div className="flex flex-col items-center justify-center gap-2">
            <GeoscapeDeveloperSvg
              fill={isDark ? "white" : "black"}
              className="w-[80vw] h-[100px]"
            />
            <ResendVerification />
          </div>
        </Route>
        <Route path="*">
          <Redirect to={Routes.signIn} />
        </Route>
      </Switch>

      <div className="absolute bottom-0 left-0 p-2">
        <span className="text-xs text-muted-foreground">
          v2.0.0.{import.meta.env.VITE_BUILD_NO}
        </span>
      </div>
    </div>
  );
};
